import { GetServerSideProps, NextPage } from 'next'

import { retrieveQAFeed, retriveBlogList } from '../../../api/feed'
import { retrieveSeoData } from '../../../api/seo'
import { retrieveTopics } from '../../../api/topics'
import ChannelPage from '../../../components/ChannelPage'
import MetaTags from '../../../components/MetaTags'
import { CustomisedFeedObjectQuestion } from '../../../components/NewQuestion'
import { normailzeData } from '../../../components/NewQuestion/utils'
import { getLocale, localeToLanguage } from '../../../data/intl'
import useScreenName from '../../../hooks/clevertap/useScreenName'
import { useLingui } from '../../../hooks/locale/useLingui'
import { BlogItem, FeedAge, PageMetadata, TopicStub } from '../../../interfaces'
import { setCookieId } from '../../../utils/cookie'
import { getQuery } from '../../../utils/utm'

interface Props {
  ageType: string
  blogDataList: Array<BlogItem>
  feedAge: FeedAge
  qaDataList: Array<CustomisedFeedObjectQuestion>
  seoData?: PageMetadata
  topics: Array<TopicStub>
}

const hideCrumbBar = new Set(['Lifestages'])
const defaultAgeType = 'ALL'
const pageName = 'Lifestage Page'

const Channel: NextPage<Props> = props => {
  const ScreenProvider = useScreenName(pageName, { feedAge: props.feedAge, ageType: props.ageType })
  const LinguiProvider = useLingui()
  const title = `${props.feedAge} | Tips and Products`
  return (
    <ScreenProvider>
      <MetaTags ogTitle='Pregnancy,Parenting & Baby Care Tips  | Topics' seoData={props.seoData} title={title} />
      <LinguiProvider>
        <div className='bg-w'>
          <ChannelPage
            ageType={props.ageType}
            blogDataList={props.blogDataList}
            feedAge={props.feedAge}
            hideCrumbBar={hideCrumbBar}
            qaDataList={props.qaDataList}
            topics={props.topics}
          />
        </div>
      </LinguiProvider>
    </ScreenProvider>
  )
}

export const getServerSideProps: GetServerSideProps = async ctx => {
  await setCookieId(ctx)
  const feedAge = (getQuery(ctx.query.feedAge) as string).toUpperCase() as FeedAge
  const locale = getLocale(ctx.locale)
  const language = localeToLanguage(locale)

  const [blogDataList, qaDataList, seoData, topics] = await Promise.all([
    retriveBlogList(feedAge, defaultAgeType, language, 0, 'LIFESTAGE'),
    retrieveQAFeed(locale, defaultAgeType, feedAge),
    retrieveSeoData(ctx.resolvedUrl),
    retrieveTopics(language, feedAge, defaultAgeType),
  ])

  return {
    props: {
      ageType: defaultAgeType,
      blogDataList: blogDataList.payload?.blogs ?? [],
      feedAge,
      qaDataList: normailzeData(qaDataList),
      seoData,
      topics,
    },
  }
}

export default Channel
